import React from 'react';
import { Col, FloatingLabel, Form } from 'react-bootstrap';
import Select from 'react-select';

function CurrencyDropDown(props) {
  const handleChangeCurrency = (data) => {
    if (data != null) {
      props.sendCurrencyData(data);
    }
  };

  return (
    <Col md={props.md}>
      <FloatingLabel
        controlId="cur"
        label={props.label}
        className={`fixedFloatingLabel mb-3 ${props.className || ''}`}
      >
        <Select
          id="cur"
          required
          options={props.currencyData}
          isClearable={props.isClearable}
          onChange={(val) => handleChangeCurrency(val)}
          value={{ label: props.currency, value: props.currencyCode }}
          components={{ Option: props.IconOption }}
        />
        {props.validation && (
          <Form.Control.Feedback>{props.validation}</Form.Control.Feedback>
        )}
      </FloatingLabel>
    </Col>
  );
}
export default CurrencyDropDown;
